import styled from 'styled-components';

export const AppContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;
